module.exports = __webpack_public_path__ + "images/line_at/img_copy_c8097d282c7c574f2c2cc505cb9ccff7.png";